import axios from 'axios'
import store from '../store'
//import router from '../router'

var instance = axios.create({
    baseURL: 'https://api.ins4models.com',
    timeout: 100000,
});

const req = {
    requestsPending : 0,
    pending: () => {
        req.requestsPending++;
        store.dispatch(`loader/show`);
        //console.log('pending', req.requestsPending);
    },
    done: () => {
        req.requestsPending--;
        if (req.requestsPending <= 0) {
            store.dispatch(`loader/hide`);
        }
        //console.log('done', req.requestsPending);
    }
  };

// Add a request interceptor
instance.interceptors.request.use(function (config) {
    req.pending();
    const token = store.state.token;
    config.headers['Authorization'] = 'Bearer ' + token;

    return config;
}, function(error){
    //requestsPending--;
    req.done();
    return Promise.reject(error);
});

//Add a response interceptor
instance.interceptors.response.use((response) => {
    req.done();
    return response
 }, function (error) {
    req.done();
    //console.log("*** interceptors.response ***");
    const originalRequest = error.config;
    //const errorText = error.response.data.error
 
    if (error.response.status === 401 && originalRequest.url === '/oauth/token') {
        //router.push('/login');
        return Promise.reject(error);
    }
 
    if (error.response.status === 401 && !originalRequest._retry) { 
        originalRequest._retry = true;
        const refreshToken = store.state.refresh_token;
        //console.log("refreshToken", refreshToken);
        return store.dispatch('refreshToken', refreshToken)
            .then(() =>  {
                //console.log('success redirecting ????', resp);
                //return router.go()
                return instance(originalRequest); // redirect to original request
            })
            //.catch(err => //console.log(err))
    }

    return Promise.reject(error);
 });


export default instance